(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kme-sliding-product-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kme-product-slider')) {
  customElements.define('kme-product-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.kme-slider__track');
      this.buttons = this.querySelectorAll('[data-direction]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.buttons[0].disabled = this.track.scrollLeft <= 1;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 1;
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const card = this.track.querySelector('.kme-slider__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({ left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options));
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
